import React from 'react';
import { Grid, Cell } from '@carvana/showroom-grid';
import { CarvanaHeaderContext } from '@carvana/header';
import { useCoreEvents, eventNames } from '@carvana/core-events';
import {
  HeroLoginWrapper,
  HeroLoginText,
  Paragraph,
  SignInButton
} from './login-create-account.styles';

export const LoginCreateAccount = () => {
  const { emit } = useCoreEvents();

  const openAccountModalSignIn = () => {
    emit(eventNames.accountModal.open, {
      step: 'email-form',
      OnAuthenticatedSuccess: (x) => {
        window.location.reload();
        return;
      },
      SignIn: {
        onFailure: (x) => {
          console.error('unable to login', x);
          return;
        }
      }
    });
  };

  return (
    <HeroLoginWrapper>
      <HeroLoginText>
        <Paragraph>Log in for personalized service</Paragraph>
      </HeroLoginText>

      <CarvanaHeaderContext.Consumer>
        {() => (
          <Grid>
            <Cell>
              <SignInButton onClick={openAccountModalSignIn}>Sign In</SignInButton>
            </Cell>
          </Grid>
        )}
      </CarvanaHeaderContext.Consumer>
    </HeroLoginWrapper>
  );
};
